import { LayoutFAQs } from "@/components/terra/layouts/LayoutFAQs/LayoutFAQs"
import { ThemeDivider } from "@/components/terra/component/ThemeDivider/ThemeDivider"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { createRichTextOptions } from "@/lib/formatters/formatRichText"
import { resolveHyperlinkLinks } from "@/lib/formatters/richTextLinks"
import { DEFAULT_PUBLIC_LANG } from "@/lib/locale/toContentfulLocale"
import { handleButtons } from "@/lib/utils"
export default async function MXPLayoutFaq(props: any) {
  const {
    value,
    index,
    divider,
    headerElement,
    lang = DEFAULT_PUBLIC_LANG,
  } = props

  const faqItemEntries = value.itemsCollection?.items ?? []
  const links = await resolveHyperlinkLinks(
    [value?.description, ...faqItemEntries.map((item: any) => item?.description)],
    lang,
  )
  const richTextOptions = createRichTextOptions(lang, links)

  const faqItems: any[] = []
  faqItemEntries.map((faqItem: any) => {
    const buttonData = handleButtons([faqItem.ctaLink], false, lang)

    faqItems.push({
      headline: faqItem.headline,
      description: faqItem.description?.json
        ? documentToReactComponents(faqItem.description.json, richTextOptions)
        : "",
      ctaLink: buttonData?.[0],
    })
  })
  const buttons: any[] = handleButtons(value.buttonsCollection?.items, true, lang)

  const displayMode = value.isAccordion ? "t2-collapsed" : "t2-expanded"

  const dividerClasses = `section-divider-wrap ${value.theme}`
  return (
    <>
      <LayoutFAQs
        key={index}
        headerElement={headerElement}
        eyebrow={value.eyebrow}
        header={value.header}
        subheader={value.subheader}
        description={
          value?.description?.json
            ? documentToReactComponents(value.description.json, richTextOptions)
            : undefined
        }
        presetTheme={value.theme}
        faqItems={faqItems}
        faqType={displayMode}
        buttons={buttons || []}
        isWrapped={true}
        isHeaderBig={value.isHeaderBig || false}
      />
      {divider && (
        <div className={dividerClasses}>
          <ThemeDivider currentTheme={value.theme} />
        </div>
      )}
    </>
  )
}
